import { DropdownOptions } from "../Components/dropdownOptions";

export const getSelectedOptionFromValue = (
  options: Array<DropdownOptions>,
  value: string | number | null,
): DropdownOptions | null => {
  return (options || []).find((option) => option?.value === value) || null;
};
